import { Card, Typography, Grid, Divider, Box, CardContent, Stack, Avatar, ListItemAvatar, List, ListItem, ListItemText, Badge, TextField, Button, Menu, MenuItem, Tooltip, Paper, Alert } from '@mui/material';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { fetchAgeVerify, fetchMemberOrders, fetchMembersDetails, updateCardBlock, updateMember } from '../../../redux/slices/member';
import AngleRightIcon from 'common/customIcons/angle_right';
import MDButton from 'components/MDButton';
import EditIcon from 'common/customIcons/edit';
import colors from 'assets/theme/base/colors';
import productImage from 'assets/images/placeholder-image.png';
import moment from 'moment';
import { formatTimestampToDateView } from 'utilities/common';
import { addSpaceBeforeCapital } from 'utilities/common';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { formatUsPhoneNumber } from 'utilities/common';
import Zoom from 'react-medium-image-zoom';
import InActiveIcon from 'common/customIcons/inactive';
import DeliveredIcon from 'common/customIcons/delivered';
import ReturnApprovedIcon from 'common/customIcons/returnApproved';
import ReturnRequestIcon from 'common/customIcons/returnRequest';
import InProgressIcon from 'common/customIcons/inprogress';
import { orderDetailStatus } from 'utilities/common';
import { returnRequestStatus } from 'utilities/common';
import { capitalizeText } from 'utilities/common';
import { openCustomDrawer, openCustomModalDialog } from '../../../redux/slices/modalSlice';
import { formatDeliveryAddress } from 'utilities/common';
import { isEmptyObject } from 'utilities/common';
import dayjs from 'dayjs';
import { openSnackbar } from '../../../redux/slices/common';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WalletLogs from '../walletlogs';
import { LocationOnOutlined, PictureAsPdfOutlined, Star } from '@mui/icons-material';
// import { MemberBirthday } from 'common/memberBadges';
// import { NewMember } from 'common/memberBadges';
// import { VipMember } from 'common/memberBadges';
import defaultProductImage from '../../../assets/images/placeholderproduct.svg';
import { getData } from 'utilities/common';
import { STILO } from 'utilities/constants';
import { MemberBirthday } from 'common/memberBadges';
import { NewMember } from 'common/memberBadges';
import { VipMember } from 'common/memberBadges';
import { Memberguest } from 'common/memberBadges';
import { getImageExtension } from 'utilities/common';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';


export default function MemberDetails() {
  const { grey } = colors;
  const { memberId } = useParams();
  const [formData, setFormData] = useState({
    blockOnlinePayments: {
      status: false,
      blockedReason: "",
    }

  })
  const [searchParams, setSearchParams] = useSearchParams();

  const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [isBlock, setIsBlock] = useState(false)
  const [errors, setErrors] = useState({});
  const { user } = useSelector(state => state.auth);
  const adminsMode = getData('adminsMode')
  const [ageVerify, setAgeVerify] = useState({})

  const isStilo = JSON.parse(adminsMode) === STILO
  const { memberDetails = {}, loading = false, memberOrders = [], ordersTotal = 0 } = useSelector(state => state.members) || {};
  const {
    age,
    createdDate,
    verifyMethod,
    deliveryAddress = {},
    dob,
    email,
    fullName,
    gender,
    isBirthdayToday,
    vipMember,
    newMember,
    idImage,
    memberShipGroup,
    memberType,
    deliveryAddresses = [],
    // isBirthdayToday = '',
    // vipMember = '',
    // newMember = '',
    phone,
    walletAmount = 0,
    profileImage,
    physician,
    issueDate = '',
    rec = "",
    recPhoto = '',
    guestCheckout,
    idAddress = {},
    dlExpiration = '',
    medicinaldlExpiration = '',
    selfiePhotoUrl = ''
  } = memberDetails;


  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (!(formData?.blockOnlinePayments?.status && formData?.blockOnlinePayments?.blockedReason)) {
      setAnchorEl(event.currentTarget);
      setFormData((prevData) => ({
        ...prevData,
        blockOnlinePayments: {
          status: true,
          blockedReason: formData?.blockOnlinePayments?.blockedReason,
        },
      }));
    }
  };



  const orderStatusColor = {
    'delivered': '#04B072',
    // "return_approved": "#24CA49",
    'approved': '#24CA49',
    'return_request': '#000000',
    'cancelled': '#FD4438',
    'rejected': '#FD4438',
    'awaiting_shipment': '#8E0CF5',
    'shipped': '#24CA49',
  };

  const orderStatusIcons = {
    'delivered': <DeliveredIcon width="18px" height="18px" flex="none" />,
    'approved': <ReturnApprovedIcon width="18px" height="18px" flex="none" />,
    'return_request': <ReturnRequestIcon width="18px" height="18px" flex="none" />,
    'cancelled': <InActiveIcon width="18px" height="18px" flex="none" />,
    'awaiting_shipment': <InProgressIcon width="18px" height="18px" flex="none" />,
    'rejected': <InActiveIcon width="18px" height="18px" flex="none" />,
  };
  useEffect(() => {
    if (memberId) {
      dispatch(fetchMembersDetails(memberId));
      dispatch(fetchMemberOrders({ filters: {}, memberId }));
    }
  }, [memberId]);



  const handleToggleBlock = () => {
    // open modal//
    if (formData?.blockOnlinePayments?.status) {
      dispatch(openCustomModalDialog({
        modal: 'ACTIVE_CARD',
        modalData: {
          memberId
        }
      }))
    }

    // modal end//

  };

  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  useEffect(() => {
    if (!isEmptyObject(memberDetails)) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        blockOnlinePayments: {
          ...prevFormData.blockOnlinePayments,
          blockedReason: memberDetails.blockOnlinePayments?.blockedReason || '',
          status: memberDetails.blockOnlinePayments?.status
        },
      }));


    }
  }, [memberDetails]);

  useEffect(() => {
    setFormData({ ...formData, createdBy: user?.name });
  }, [user?.name]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (memberId) {

      // Check if blockedReason is empty or just whitespace
      if (!formData?.blockOnlinePayments?.blockedReason || formData?.blockOnlinePayments?.blockedReason.trim() === '') {
        // Set the error for blockedReason
        setErrors({ blockedReason: 'A block reason is required when blocking payments.' });

        return; // Stop further submission
      } else {
        // Reset errors if blockedReason is valid
        setErrors({});
      }

      let payload = {
        "memberId": memberId
      };
      payload = {
        ...payload,
        blockOnlinePayments: {
          status: formData?.blockOnlinePayments?.status,
          blockedReason: formData?.blockOnlinePayments?.blockedReason,
          blockedDate: new Date().valueOf(),
          blockedBy: user?.name
        }
      }

      dispatch(updateCardBlock({ data: payload })).unwrap().then((res) => {
        showError(res?.message, 'success');
        setAnchorEl(false)
        dispatch(fetchMembersDetails(memberId));
        // navigate('/members');
      }).catch((err) => {
        showError(err?.message, 'error');
      });
    }

  };
  const handleDownload = (fileUrl, fileName) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName || 'download'; // Default filename if not provided
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  useEffect(() => {
    if (email && isStilo) {
      const payload = {
        email: email
      }
      dispatch(fetchAgeVerify(payload)).unwrap().then((res => {
        setAgeVerify({})
      })).catch((err) => {
        setAgeVerify(err)

      })
    }

  }, [email])

  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Members", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Members", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Members", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Members", "Delete");

  return (
    <CommonLayout>
      {canView &&
        fullRoleTab === 'walletlogs' ?
        <WalletLogs /> :
        <Box p={{ xs: 2, sm: 3, lg: 4 }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent='space-between' gap={2} mb={3.5}>
            <Box style={{ cursor: "Pointer" }} onClick={() => navigate(-1)} display="flex" alignItems="center" color='text.main' lineHeight={1}>
              <AngleRightIcon fontSize="14px" />
              <Typography variant='h6' fontWeight="semibold" ml={.75}>Members</Typography>
            </Box>

            <Box display='flex' alignItems='center' gap={1.25}>
              {memberId &&
                (
                  <Box display='flex' alignItems='center' gap={2.5}>
                    <Typography variant='h5' fontWeight='semibold' color='secondary'>Online Payment:</Typography>
                    <Stack direction="row" alignItems="center" gap={.75} lineHeight={1} p={.75} borderRadius={2} bgcolor="#ffffff">
                      <MDButton
                        sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                        type='button'
                        variant={formData.blockOnlinePayments.status !== true ? 'contained' : 'text'}
                        color={formData.blockOnlinePayments.status !== true ? 'success' : 'dark'}
                        size="small"
                        onClick={(e) => canEdit ? handleToggleBlock(e) : ""}
                        style={{ cursor: formData.blockOnlinePayments.status !== true ? "auto" : "pointer" }}

                      >
                        Active
                      </MDButton>
                      <MDButton
                        sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                        type='button'
                        variant={formData.blockOnlinePayments.status === true ? 'contained' : 'text'}
                        color={formData.blockOnlinePayments.status === true ? 'error' : 'dark'}
                        size="small"
                        // onClick={handleClick}
                        onClick={(e) => canEdit ? handleClick(e) : ""}
                        style={{ cursor: formData.blockOnlinePayments.status === true ? "auto" : "pointer" }}
                      >
                        Block
                      </MDButton>

                    </Stack>

                    {
                      (memberDetails?.blockOnlinePayments?.status) && <Tooltip title={memberDetails?.blockOnlinePayments?.blockedReason || ''}>
                        <InfoOutlinedIcon color='#656575' style={{ marginLeft: "-15px", marginRight: "10px" }} />
                      </Tooltip>
                    }

                    {(anchorEl) &&
                      <Menu
                        id="block-member-menu"
                        anchorEl={anchorEl}
                        open={open}
                        // onClose={handleClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                          className: 'popover-block-member'
                        }}
                      >
                        <Box display='flex' gap={1.25} flexDirection='column'>
                          <Typography variant='h5' fontWeight='semibold' color='#2E2E3A' style={{ fontSize: '16px' }}>Add Reason</Typography>
                          <Box>
                            <TextField
                              className="form-input"
                              name='memo'
                              value={formData?.blockOnlinePayments?.blockedReason || ''}
                              error={Boolean(errors?.blockedReason)} helperText={errors?.blockedReason}
                              onChange={(e) => {
                                const newBlockedReason = e.target.value;
                                setFormData((prevFormData) => ({
                                  ...prevFormData,
                                  blockOnlinePayments: {
                                    ...prevFormData.blockOnlinePayments,
                                    blockedReason: newBlockedReason, // Update blockedReason in formData
                                  },
                                }));
                              }}
                              fullWidth
                              multiline
                              rows={4}
                              variant='outlined'
                              label="Block Reason"
                            />
                          </Box>
                          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent='end' spacing={1.25}>
                            <MDButton
                              sx={{ minWidth: '120px' }}
                              type='button'
                              variant='outlined'
                              color='dark'
                              size="small"
                              onClick={() => { setAnchorEl(false); dispatch(fetchMembersDetails(memberId)) }}
                            >
                              Cancel
                            </MDButton>
                            <MDButton
                              sx={{ minWidth: '120px' }}
                              type='button'
                              variant='contained'
                              color='primary'
                              onClick={handleSubmit}
                              disabled={loading}
                              loading={loading}
                              size="small"
                            >Save</MDButton>
                          </Stack>
                        </Box>
                      </Menu>
                    }
                  </Box>
                )
              }

              <Box>
                <MDButton
                  sx={{ minWidth: '220px' }}
                  type='button'
                  variant='contained'
                  color='primary'
                  className="gap-2"
                  style={{ fontWeight: "500", padding: "5px 20px" }}
                  onClick={() => { canEdit ? dispatch(openCustomDrawer({ drawer: 'WALLET', drawerData: memberDetails })) : "" }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                    <path d="M11.125 1.625H1.875C0.841115 1.625 0 2.46612 0 3.5V10.5C0 11.5339 0.841115 12.375 1.875 12.375H11.125C12.1589 12.375 13 11.5339 13 10.5V3.5C13 2.46612 12.1589 1.625 11.125 1.625ZM12.25 8.125H9.5C8.87969 8.125 8.375 7.62034 8.375 6.99999C8.375 6.37965 8.87966 5.87498 9.5 5.87498H12.25V8.125ZM12.25 5.125H9.5C8.46612 5.125 7.62501 5.96611 7.62501 6.99999C7.62501 8.03387 8.46612 8.87499 9.5 8.87499H12.25V10.5C12.25 11.1203 11.7453 11.625 11.125 11.625H1.875C1.25468 11.625 0.749988 11.1203 0.749988 10.5V3.5C0.749988 2.87968 1.25465 2.37499 1.875 2.37499H11.125C11.7453 2.37499 12.25 2.87965 12.25 3.5V5.125Z" fill="white" />
                    <path d="M9.99999 6.625H9.49999C9.29288 6.625 9.125 6.79291 9.125 6.99999C9.125 7.20711 9.29291 7.37499 9.49999 7.37499H9.99999C10.2071 7.37499 10.375 7.20708 10.375 6.99999C10.375 6.79288 10.2071 6.625 9.99999 6.625Z" fill="white" />
                  </svg>
                  <span>Wallet Balance: </span>
                  <span>{walletAmount ? '$' + walletAmount : '$0'}</span>
                </MDButton>
              </Box>
            </Box>

          </Stack>

          <Grid container spacing={2.5} mb={4}>
            <Grid item xs={12} lg={7}>
              <Card variant='detailsCard' sx={{ height: '100%', overflow: 'hidden' }}>
                <CardContent sx={{ p: { xs: 2, md: 3.5 }, pb: 0 }}>

                  {memberDetails?.blockOnlinePayments?.status &&
                    <Box display="flex" alignItems="center" justifyContent="center" mb={1} style={{ backgroundColor: "#FF7F7F", color: "#ffffff", margin: "-28px -28px 28px -28px", fontSize: "16px", padding: "6px 0", fontWeight: "700" }}>
                      {memberDetails?.blockOnlinePayments?.status ? 'Card Blocked' : ''}
                    </Box>
                  }
                  {
                    ageVerify?.isBlocked && <Box display="flex" alignItems="center" justifyContent="center" gap={1} style={{ backgroundColor: "#eaa41e", color: "#ffffff", margin: "0 0 20px 0", fontSize: "16px", padding: "6px 10px", fontWeight: "700", borderRadius: "6px" }} error={ageVerify?.message}>
                      <InfoOutlinedIcon style={{ width: "18px", height: "18px" }} />
                      {ageVerify?.message}
                    </Box>
                  }
                  <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={3}>
                    <Typography variant='h5'>Member Details </Typography>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
                      {
                        canEdit &&
                        <>
                          <div className="d-flex align-items-start justify-content-start flex-column gap-2 client-list-rep">
                            <MDButton onClick={() => dispatch(openCustomModalDialog({ modal: 'HOT_NOTES', modalData: { memberPayload: memberDetails, memberId, allowAdd: true } }))} size="small" variant="outlined" color='success' className="font-weight-600 border-radius-6 fs-small" style={{ minWidth: "90px", minHeight: "34px" }}>
                              Hot Notes
                            </MDButton>
                          </div>
                          <MDButton
                            type='button'
                            variant='outlined'
                            color='dark'
                            size="small"
                            startIcon={<EditIcon width='15px' height='15px' />}
                            sx={{ borderRadius: 1.5 }}
                            onClick={() => navigate(`/members/${memberId}`)}
                            style={{ minWidth: "90px", minHeight: "34px" }}
                          >
                            Edit
                          </MDButton>
                        </>
                      }



                    </Stack>
                  </Stack>
                  <Stack direction="row" spacing={1.25} mb={4}>
                    {/* <Zoom classDialog='custom-zoom'>
                         <img style={{ borderRadius: '20px', width: '108px', height: '108px', objectFit: 'contain' }} src={idImage || productImage} alt="No Image Found" />
                         </Zoom> */}
                    <Stack direction="row" spacing={1.25} mb={4}>
                      <Zoom classDialog='custom-zoom'> <img style={{ borderRadius: "20px", width: "108px", height: "108px", objectFit: "cover" }} src={idImage || productImage} alt="No Image Found" /></Zoom>
                    </Stack>
                  </Stack>

                  <Grid container alignItems="center" spacing={3.5} mb={1}>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Name</Typography>
                      <Stack direction='row'>
                        <Typography variant='h6' fontWeight="medium" sx={{ textTransform: 'capitalize' }}>
                          {fullName?.toLowerCase()} {guestCheckout && <Memberguest />}
                        </Typography>
                        {/* {
                            fullName && <div className="ml-2 d-flex align-items-center justify-content-start gap-1 cus-badge">
                              {isBirthdayToday && <MemberBirthday />} {newMember && <NewMember />} {vipMember && <VipMember />}
                            </div>
                          } */}
                      </Stack>

                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Email</Typography>
                      <Typography variant='h6' fontWeight="medium">{email}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Age</Typography>
                      <Typography variant='h6' fontWeight="medium">{age}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Gender</Typography>
                      <Typography variant='h6' fontWeight="medium" sx={{ textTransform: 'capitalize' }}>
                        {
                          isStilo ?
                            <>
                              {
                                gender ? <span style={{ textTransform: 'capitalize' }}>
                                  {(gender?.toLowerCase() === 'm' || gender?.toLowerCase() === 'male') ? "Male" : (gender?.toLowerCase() === 'f' || gender?.toLowerCase() === 'female') ? "Female" : "Other"}
                                </span> : '-'
                              }
                            </>
                            :
                            <>
                              {gender?.toLowerCase() || '-'}
                            </>

                        }
                      </Typography>
                    </Grid>
                    {
                      isStilo ?
                        <Grid item xs={12} md={6}>
                          <Typography variant='body2' color={grey[600]}>DOB</Typography>
                          <Typography variant='h6' fontWeight="medium">{dob ? moment(dob).utc().format('MM/DD/YYYY') : '-'}</Typography>
                        </Grid>
                        :
                        <Grid item xs={12} md={6}>
                          <Typography variant='body2' color={grey[600]}>DOB</Typography>
                          <Typography variant='h6' fontWeight="medium">{dob ? moment(dob).format('MM/DD/YYYY') : '-'}</Typography>
                        </Grid>
                    }
                    {/* <Grid item xs={12} md={6}>
                        <Typography variant='body2' color={grey[600]}>DOB</Typography>
                        <Typography variant='h6' fontWeight="medium">{dob ? moment(dob).utc().format('MM/DD/YYYY') : '-'}</Typography>
                      </Grid> */}
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Phone</Typography>
                      <Typography variant='h6' fontWeight="medium">{phone ? formatUsPhoneNumber(phone) : '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Member ID</Typography>
                      <Typography variant='h6' fontWeight="medium">{memberId}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Member Type</Typography>
                      <Typography variant='h6' fontWeight="medium">{memberType ? addSpaceBeforeCapital(memberType) : '-'}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Membership Group</Typography>
                      <Typography variant='h6' fontWeight="medium">{memberShipGroup ? addSpaceBeforeCapital(memberShipGroup) : '-'}</Typography>
                    </Grid>
                    {
                      isStilo &&
                      <>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Typography variant='body2' color={grey[600]}>Expiration Date</Typography>
                          <Typography variant='h6' fontWeight="medium">{dlExpiration ? moment(dlExpiration).format('MM/DD/YYYY') : '-'}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Typography variant='body2' color={grey[600]}>Medicinal Expiration</Typography>
                          <Typography variant='h6' fontWeight="medium">{medicinaldlExpiration ? moment(medicinaldlExpiration).format('MM/DD/YYYY') : '-'}</Typography>
                        </Grid>
                      </>
                    }
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Source</Typography>
                      <Typography variant='h6' fontWeight="medium">{verifyMethod ? verifyMethod === 'Site' ? 'Website' : capitalizeText(verifyMethod) || 'Admin' : '--'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Created on</Typography>
                      <Typography variant='h6' fontWeight="medium">{createdDate ? formatTimestampToDateView(createdDate) : '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Total Number of Orders</Typography>
                      <Typography variant='h6' fontWeight="medium">{ordersTotal}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant='body2' color={grey[600]}>Wallet</Typography>
                      <Typography variant='h6' fontWeight="medium">{walletAmount ? '$' + walletAmount : '$0'}</Typography>
                    </Grid>
                    {(memberDetails?.memberType === "MedicinalUser" && isStilo) &&
                      <>
                        <Grid item xs={12} md={6}>
                          <Typography variant='body2' color={grey[600]}>Physician Name</Typography>
                          <Typography variant='h6' fontWeight="medium">{physician?.fullName}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant='body2' color={grey[600]}>Rec #</Typography>
                          <Typography variant='h6' fontWeight="medium">{rec ? rec : "-"}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant='body2' color={grey[600]}>Issue Date</Typography>
                          <Typography variant='h6' fontWeight="medium">{issueDate ? issueDate : "-"}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          {getImageExtension(recPhoto) !== 'pdf' ?
                            <>
                              <Typography variant='body2' color={grey[600]} mb={2}>MMIC or Medical Recommendation</Typography>
                              <Zoom classDialog='custom-zoom'>
                                <img style={{ borderRadius: "20px", maxWidth: "100%", objectFit: "contain", maxHeight: "200px" }} src={recPhoto || productImage} alt="No Image Found" />
                              </Zoom>
                            </>
                            :
                            <>
                              {/* <Tooltip key={recPhoto} title={recPhoto} arrow placement="top">
                                                            <p style={{ cursor: "pointer" }} className='text-truncate' onClick={() => handleDownload(recPhoto)}
                                                            >{recPhoto}</p></Tooltip> */}
                              <Alert
                                severity="primary"
                                icon={<PictureAsPdfOutlined />}
                                action={
                                  <Button color="primary" size="small" onClick={() => handleDownload(recPhoto)}>
                                    Download
                                  </Button>
                                }
                              >
                                <Typography variant='body2'>MMIC or Medical Recommendation</Typography>
                              </Alert>
                            </>
                          }
                        </Grid>
                        {/* <Grid item xs={12} md={6}>
                            <Typography variant='body2' color={grey[600]} mb={2}>MMIC or Medical Recommendation</Typography>
                            {getImageExtension(recPhoto) !== 'pdf' ?
                              <Zoom classDialog='custom-zoom'>
                                <img style={{ borderRadius: "20px",  maxWidth: "100%", objectFit: "contain", maxHeight: "200px" }} src={recPhoto || productImage} alt="No Image Found" />
                              </Zoom>
                              :
                              <Tooltip key={recPhoto} title={recPhoto} arrow placement="top"><p style={{ cursor: "pointer" }}  className='text-truncate' onClick={() => handleDownload(recPhoto)}
                              >{recPhoto}</p></Tooltip>
                            }
                          </Grid> */}
                      </>
                    }
                    {memberDetails?.blockOnlinePayments?.status &&
                      <Grid item xs={12} md={6}>
                        <Typography variant='body2' color={grey[600]}>Card Blocked Reason</Typography>
                        <Typography variant='h6' fontWeight="medium">{memberDetails?.blockOnlinePayments?.blockedReason || ''}</Typography>
                      </Grid>
                    }
                    {
                      memberDetails?.recId && <Grid item xs={12} md={6}>
                        <Typography variant='caption' color={grey[600]}>Rec ID</Typography>
                        <Link to={memberDetails?.recId}>
                          <a target='_blank'>
                            <Typography variant='h6' fontWeight="medium" lineHeight="1.25">{memberDetails?.recId || '-'}</Typography>
                          </a>
                        </Link>
                      </Grid>
                    }
                    {
                      isStilo &&
                      <Grid item xs={12}>
                        <Typography variant='body2' fontWeight="semibold" mb={1} color={grey[600]}>Identification Address </Typography>
                        <Typography variant='h6' fontWeight="regular" lineHeight="1.85">
                          {
                            idAddress?.apartment && <>

                              <b style={{ fontWeight: 600 }}>Apartment Number: </b>{idAddress.apartment || '-'} <br />
                            </>
                          }
                          <b style={{ fontWeight: 600 }}>Address: </b>{idAddress.address} <br />
                          <b style={{ fontWeight: 600 }}>City: </b>{idAddress.city} <br />
                          <b style={{ fontWeight: 600 }}>State: </b>{idAddress.state} <br />
                          <b style={{ fontWeight: 600 }}>Zip Code: </b>{idAddress?.zipcode || idAddress?.zipCode}
                        </Typography>
                      </Grid>
                    }
                    {
                      isStilo ?
                        <>
                          {
                            deliveryAddresses?.length !== 0 &&
                            <Grid item xs={12} mt={2}>
                              <Typography variant='body2' fontWeight="semibold" mb={2} color={grey[600]}>Member Addresses </Typography>
                              <Grid container spacing={2}>
                                {
                                  deliveryAddresses?.map((data) => {
                                    return <>
                                      <Grid item xs={12} sm={6} xxxl={4}>
                                        <Card sx={{ boxShadow: "none", border: "1px solid", borderColor: grey[300], color: "text.main", height: "100%", wordBreak: "break-word" }}>
                                          <CardContent sx={{ px: 2, py: 1.75 }}>
                                            <Box display="flex" alignItems="start" gap={1} mb={1}>
                                              <Typography display="flex" alignItems="start" gap={0.5} lineHeight={1.25} variant="h6" ml={-0.5}>
                                                <LocationOnOutlined fontSize="small" color="primary" />
                                                {data?.tag}
                                              </Typography>

                                              {data?.isPrimary &&
                                                <Typography display="flex" alignItems="center" gap={0.25} flexShrink={0} variant="caption" fontWeight={600} color="primary" ml="auto">
                                                  <Star sx={{ fontSize: "1rem !important", mt: -0.125 }} />
                                                  Primary
                                                </Typography>
                                              }
                                            </Box>

                                            <Typography variant="body2" component="p" fontWeight={400} color={grey[600]} mb={-1}>
                                              {data?.apartment ? `${data?.apartment}, ` : ''}
                                              {data?.address ? `${data?.address}, ` : ''}
                                              {data?.city ? `${data?.city}, ` : ''}
                                              {data?.state ? `${data?.state}, ` : ''}
                                              {data?.country ? `${data?.country}, ` : ''}
                                              {data?.zipcode || data?.zipCode ? `${data?.zipcode || data?.zipCode} ` : ''}
                                            </Typography>
                                          </CardContent>
                                        </Card>
                                      </Grid>
                                    </>
                                  })
                                }
                              </Grid>
                            </Grid>
                          }</>
                        : <Grid item xs={12} mt={2}>
                          <Typography variant='body2' fontWeight="semibold" mb={1} color={grey[600]}>Member Address </Typography>
                          <Typography variant='h6' fontWeight="regular" lineHeight="1.85">
                            {
                              deliveryAddress?.apartment && <>

                                <b style={{ fontWeight: 600 }}>Apartment Number: </b>{deliveryAddress.apartment || '-'} <br />
                              </>
                            }
                            <b style={{ fontWeight: 600 }}>Address: </b>{deliveryAddress.address} <br />
                            <b style={{ fontWeight: 600 }}>City: </b>{deliveryAddress.city} <br />
                            <b style={{ fontWeight: 600 }}>State: </b>{deliveryAddress.state} <br />
                            <b style={{ fontWeight: 600 }}>Zip Code: </b>{deliveryAddress?.zipcode || deliveryAddress?.zipCode}
                          </Typography>
                        </Grid>
                    }

                  </Grid>
                  <div className='cus-img-full-sec'>
                    {
                      (isStilo && selfiePhotoUrl) &&
                      <div className='cus-image-half'>
                        <Zoom classDialog='custom-zoom'> <img style={{ borderRadius: "20px", width: "100%", maxWidth: "100%", objectFit: "contain", maxHeight: "300px" }} src={selfiePhotoUrl || productImage} alt="No Image Found" /></Zoom>
                      </div>
                    }
                    <div className='cus-image-half'>
                      <Zoom classDialog='custom-zoom'> <img style={{ borderRadius: "20px", width: "100%", maxWidth: "100%", objectFit: "contain", maxHeight: "300px" }} src={idImage || productImage} alt="No Image Found" /></Zoom>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} lg={5}>
              <Card variant='detailsCard' sx={{ height: '100%', overflow: 'hidden', rowGap: '20px', p: { xs: 2, md: 3.5 } }}>
                <CardContent sx={{ px: 0, pt: 0, pb: { xs: 2, md: 3 }, mb: '-20px' }}>
                  <Stack justifyContent='space-between' direction='row' alignItems='center'>
                    <Typography variant='h5'>Recent Orders</Typography>
                    {
                      memberOrders?.length > 3 && <Link to={`/orders/member/${memberId}`}>
                        <MDButton
                          type='button'
                          variant='outlined'
                          color='dark'
                          size="small"
                          startIcon={<VisibilityIcon width='15px' height='15px' />}
                          sx={{ borderRadius: 1.5 }}
                        >
                          All Orders
                        </MDButton>
                      </Link>
                    }
                  </Stack>

                </CardContent>

                {
                  memberOrders?.length > 0 ? memberOrders?.slice(0, 4)?.map((orders => {
                    const { createdDate, items: orderItems = [], orderId } = orders;
                    return <Link key={orderId}
                      //  to={`/orders/details/${orderId}?orderDetailsTab=orderDetails`}
                      to={`/orders/details/${orderId}?orderDetailsTab=orderDetails`}
                    >
                      <CardContent sx={{ backgroundColor: '#F5F5F5', p: 0, overflow: 'hidden', borderRadius: 2, borderWidth: 1, borderStyle: 'solid', borderColor: orders?.returnRequestStatus && !orders?.warrantyStatus ? orderStatusColor['return_request'] : orders?.returnRequestStatus && orders?.warrantyStatus ? orderStatusColor[orders?.warrantyStatus] : orderStatusColor[orders?.emailStatus] }} style={{ paddingBottom: 0 }}>
                        {
                          !orders?.returnRequestStatus && !orders?.warrantyStatus !== 'rejected' && <>
                            <Box backgroundColor={orderStatusColor[orders?.emailStatus]} color="#fff" display="flex" alignItems="center" justifyContent="center" p={0.5}>
                              {
                                orderStatusIcons[orders?.emailStatus]
                              }
                              <Typography variant='caption' fontWeight="medium" ml={.5} textTransform="capitalize">{orderDetailStatus?.find((item => item?.key === orders?.emailStatus))?.value}</Typography>
                            </Box>

                          </>
                        }

                        {
                          orders?.returnRequestStatus && orders?.warrantyStatus && <Box backgroundColor={orderStatusColor[orders?.warrantyStatus]} color="#fff" display="flex" alignItems="center" justifyContent="center" p={0.5}>
                            {
                              orderStatusIcons[orders?.warrantyStatus]
                            }
                            <Typography variant='caption' fontWeight="medium" ml={.5} textTransform="capitalize">Return {returnRequestStatus?.find((item => item?.key === orders?.warrantyStatus))?.value}</Typography>
                          </Box>
                        }

                        {
                          orders?.returnRequestStatus && !orders?.warrantyStatus && <Box backgroundColor={orderStatusColor['return_request']} color="#fff" display="flex" alignItems="center" justifyContent="center" p={0.5}>
                            {
                              orderStatusIcons['return_request']
                            }
                            <Typography variant='caption' fontWeight="medium" ml={.5} textTransform="capitalize">Return Request</Typography>
                          </Box>
                        }

                        <Box px={3} pt={2} pb={2.5}>
                          <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center" justifyContent="space-between" flexWrap="wrap">
                            <Typography variant='body2' fontWeight="semibold" mr={2}>#{orderId}</Typography>
                            <Typography variant='body2' fontWeight="medium">{createdDate ? formatTimestampToDateView(createdDate) : '-'}</Typography>
                          </Stack>
                          <Divider />
                          <List>
                            {
                              orderItems?.map((order => {
                                const { product = {}, quantity } = order;
                                return <>
                                  <ListItem key={product.productId} alignItems="center" sx={{ mt: 2.5 }}>
                                    <ListItemAvatar sx={{ mr: 1.5 }} className="pro-avatar-sec">
                                      <Avatar
                                        alt="No Image Found"
                                        src={product?.productImages?.[0] ? product?.productImages?.[0] : defaultProductImage}
                                        sx={{ width: 82, height: 82, borderRadius: 4 }}
                                      />
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={
                                        <React.Fragment>
                                          <Typography variant="body2" fontWeight="medium" color={grey[600]}>{product?.brandName || '-'}</Typography>
                                          <Typography variant="h6" fontWeight="medium">{product?.productName || '-'}</Typography>
                                        </React.Fragment>
                                      }
                                      secondary={
                                        <React.Fragment>
                                          <Typography variant="h6" fontWeight="medium" mt={1}>x{quantity}</Typography>
                                        </React.Fragment>
                                      }
                                    />

                                  </ListItem>
                                  <Divider />
                                </>;
                              }))
                            }
                          </List>
                        </Box>
                      </CardContent>
                    </Link>;


                  })) : <Box height={'100%'} width="100%" display='flex' justifyContent='center' alignItems='center'>
                    <Typography variant='body2'>No Orders Found</Typography>
                  </Box>
                }
              </Card>
            </Grid>
          </Grid>
        </Box>
      }
    </CommonLayout>
  );
}
